<div *ngIf="ticket?.has_checklist_images; else cancel" class="checklists-ticket-media__actions">
  <app-icon [size]="'18'" [glyph]="'check-circled'"></app-icon>

  <div class="checklists-ticket-media__media">
    <app-loader *ngIf="isLoading" size="small"></app-loader>
    <app-icon *ngIf="!isLoading" class="checklists-ticket-media__download-icon" [size]="'18'" [glyph]="'download'" (click)="handleDownloadMedia(ticket)"> </app-icon>
  </div>
</div>
<ng-template #cancel>
  <app-icon [size]="'18'" [glyph]="'cancel-circled'"></app-icon>
</ng-template>
